/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import SuperAdminPage from "./modules/SuperAdmin/pages/SuperAdminPage";
import { OrganizationFilePage } from "./modules/OrganizationFile/pages/OrganizationFilePage";
import * as orgFeatureActions from "./modules/SuperAdmin/_redux/organization-feature/organizationFeatureAction";
import { CORPORATION } from "./config/environment";

export function Routes() {
  const { user } = useSelector(
    ({ auth }) => ({
      user: auth.user
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (user && !user.is_admin) {
      dispatch(orgFeatureActions.findCurrentOrgFeatures({}));
    }
  }, [dispatch]);

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    // ? CHECK SIMPZ OR DONORIAN
    if (CORPORATION.toLowerCase() == "simpz") {
      document.title = "MPZ";
      // ? CHECK IF ORGANIZATION HAS IMAGE
      if (user && user.organization && user.organization.image) {
        link.href =
          user.organization.image.storage + "/" + user.organization.image.path;
      } else {
        link.href = "/media/logos/dd-favico.svg";
      }
    } else {
      document.title = "Donorian";
      if (user && user.organization.image) {
        link.href =
          user.organization.image.storage + "/" + user.organization.image.path;
      } else {
        link.href = "/media/logos/favicon.ico";
      }
    }
  }, []);

  return (
    <Switch>
      {!user ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {!user ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        <Layout>
          {user.is_admin ? (
            <SuperAdminPage />
          ) : (
            <>
              {user.organization.simpz_status &&
              ["DATA_UPLOAD", "SUBMIT"].includes(
                user.organization.simpz_status
              ) ? (
                <OrganizationFilePage />
              ) : (
                <BasePage />
              )}
            </>
          )}
        </Layout>
      )}
    </Switch>
  );
}
